import { apiBaseUrl } from '../config/apiConfig';

const userApiUrl = `${apiBaseUrl}/api/users`;
// use this for production
// const userApiUrl = `https://plus-appointment.com/api/users`;


export const registerUser = async (userDetails) => {
  const response = await fetch(`${userApiUrl}/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',


    },
    body: JSON.stringify(userDetails),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};

export const loginUser = async (loginDetails) => {
  const response = await fetch(`${userApiUrl}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',

    },
    body: JSON.stringify(loginDetails),
    credentials: 'include'
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};

export const refreshToken = async () => {
  const token = localStorage.getItem('token');
  const refreshTokenValue = localStorage.getItem('refreshToken');

  if (!token || !refreshTokenValue) {
    console.error('[DEBUG] No token or refresh token found in localStorage');
    throw new Error('No token or refresh token found');
  }

  const payload = { token, refreshToken: refreshTokenValue };

  const response = await fetch(`${userApiUrl}/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    credentials: 'include'
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('[DEBUG] Error refreshing token:', errorText);
    throw new Error('Failed to refresh token');
  }

  const data = await response.json();

  if (!data.Token || !data.RefreshToken) {
    console.error('[DEBUG] WARNING: Backend did NOT return Token and RefreshToken fields as expected.');
  }

  return data;
};

export const changePassword = async (changePasswordDetails) => {
  const response = await fetch(`${userApiUrl}/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(changePasswordDetails)
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};